import { Check, Sparkles, Phone, MessageCircle } from "lucide-react";
import { Button } from "@/components/ui/button";
import { PACKAGES, PRICING_NOTE, SITE } from "@/lib/site";

export default function Packages() {
  const waLink = `https://wa.me/${SITE.whatsappRaw}?text=${encodeURIComponent(
    "Hi Vinodha Diagnostics, I'd like to know the pricing for your health check-up packages."
  )}`;

  return (
    <section id="packages" data-testid="packages-section" className="bg-[#FAFAFA]">
      <div className="max-w-7xl mx-auto px-5 md:px-10 lg:px-12 py-16 md:py-24">
        <div className="max-w-3xl">
          <span className="text-xs font-bold uppercase tracking-[0.22em] text-[#0369A1]">
            Health Packages
          </span>
          <h2 className="font-display mt-3 text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight text-[#0B2545]">
            Curated preventive health check-ups.
          </h2>
          <p className="mt-4 text-[#64748B] leading-relaxed">
            Thoughtfully designed packages for every life stage. {PRICING_NOTE}
          </p>
        </div>

        <div className="mt-12 grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6">
          {PACKAGES.map((p, i) => (
            <div
              key={p.name}
              data-testid={`package-${i}`}
              className={`relative rounded-2xl p-6 md:p-8 flex flex-col transition-all hover:-translate-y-1 ${
                p.popular
                  ? "bg-[#0B2545] text-white shadow-xl ring-1 ring-[#0B2545]"
                  : "bg-white border border-gray-200 hover:shadow-md text-[#0B2545]"
              }`}
            >
              {p.popular ? (
                <div className="absolute -top-3 left-6 inline-flex items-center gap-1.5 px-3 py-1 rounded-full bg-[#14B8A6] text-white text-[10px] font-bold tracking-[0.18em] uppercase">
                  <Sparkles className="w-3 h-3" /> {p.tag}
                </div>
              ) : (
                <span className="text-[10px] font-bold tracking-[0.2em] uppercase text-[#0369A1]">
                  {p.tag}
                </span>
              )}

              <h3 className={`font-display mt-3 text-2xl font-bold ${p.popular ? "text-white" : "text-[#0B2545]"}`}>
                {p.name}
              </h3>

              <div className={`mt-4 text-sm font-semibold ${p.popular ? "text-[#7DD3FC]" : "text-[#0369A1]"}`}>
                Contact us for pricing
              </div>

              <ul className="mt-6 space-y-3 flex-1">
                {p.features.map((f) => (
                  <li key={f} className="flex items-start gap-2.5 text-sm">
                    <Check
                      className={`w-4 h-4 mt-0.5 flex-shrink-0 ${
                        p.popular ? "text-[#14B8A6]" : "text-[#0D9488]"
                      }`}
                      strokeWidth={3}
                    />
                    <span className={p.popular ? "text-white/90" : "text-[#475569]"}>{f}</span>
                  </li>
                ))}
              </ul>

              <div className="mt-8 grid grid-cols-2 gap-2.5">
                <a
                  href={`tel:${SITE.phoneRaw}`}
                  data-testid={`package-${i}-call`}
                  className={`inline-flex items-center justify-center gap-1.5 h-11 rounded-full font-semibold text-sm transition-colors ${
                    p.popular
                      ? "bg-white text-[#0B2545] hover:bg-white/90"
                      : "bg-[#0369A1] hover:bg-[#0284C7] text-white"
                  }`}
                >
                  <Phone className="w-4 h-4" /> Call
                </a>
                <a
                  href={waLink}
                  target="_blank"
                  rel="noreferrer"
                  data-testid={`package-${i}-whatsapp`}
                  className="inline-flex items-center justify-center gap-1.5 h-11 rounded-full bg-[#25D366] hover:bg-[#1DA851] text-white font-semibold text-sm transition-colors"
                >
                  <MessageCircle className="w-4 h-4" /> WhatsApp
                </a>
              </div>
            </div>
          ))}
        </div>

        <p className="mt-8 text-xs text-[#64748B]">
          * Final approved package rates will be shared on request. Call or WhatsApp us for
          current pricing and to book your appointment.
        </p>
      </div>
    </section>
  );
}
